export default __webpack_public_path__ + "static/media/WStore_Icon_Miami.702c81ec.png";